import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import styles from './styles/TrialModalLayout.css'
import Button from 'components/forms/Button'
import Header from 'components/typography/Header'
import Endorsement from 'components/misc/Endorsement'
import P from '../typography/Paragraph'
import * as analytics from 'lib/analytics'
import { daysLeft } from '../banner/Banner'
import Modal from '../misc/Modal'

const TrialOverModal = () => {
  const history = useHistory()
  const user = useSelector(({ ui }) => ui.user)
  const [isOpen, setIsOpen] = useState(false)
  const handleClick = () => {
    history.push('/pricing')
    handleClose()
  }

  const handleClose = () => {
    setIsOpen(false)
    if (typeof window === 'undefined') {
      return
    }
    const { localStorage } = window
    localStorage.setItem('trialing-modal-closed', 'true')
  }

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const { localStorage } = window
    const trialModalClosed = localStorage.getItem('trialing-modal-closed')
    if (!trialModalClosed && user?.subscription?.status === 'trialing' && daysLeft(user?.subscription?.renewDate) <= 2) {
      setIsOpen(true)
    }
  }, [user])

  useEffect(() => {
    if (!isOpen) return
    analytics.event({
      category: 'Paywall',
      action: 'View Upgrade Modal'
    })
  }, [isOpen])

  return (
    <Modal
      toggle={handleClose}
      show={isOpen}
    >
      <div className={styles.layout}>
        <div className={styles.headerContainer}>
          <Header className={styles.header} level={4}>Your trial is almost over! 🥺</Header>
          <div className={styles.modalCloseWrapper} role='close' onClick={handleClose}>
            <i className={styles.closeIcon} />
          </div>
        </div>
        <div className={styles.upgradeLayout}>

          <div className={styles.upgradeMessage}>
            You only have {daysLeft(user?.subscription?.renewDate)} day(s) left of your trial of scite premium+
            <br />
            If you are getting value out of scite, please consider <span className={styles.bannerLink}>upgrading</span> 🙏🏼
          </div>
          <Endorsement />
          <P>
            Upgrade before your trial ends with the coupon <strong><code>TRIALOVER</code></strong> and receive 30% off any of our plans for 12 months.
          </P>
          <div className={styles.btnGroup}>
            <Button
              className={styles.btn} row
              onClick={handleClose}
            >
              Close
            </Button>
            <Button className={`${styles.btn} ${styles.upgradeBtn}`} type='submit' color='blue' onClick={handleClick} row>Upgrade Now</Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TrialOverModal
